export default "__VITE_ASSET__CCMJpH80__"